import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import AuditTimeline from '../components/audit/AuditTimeline';

const ShopHistory = () => {
  const { id } = useParams();

  return (
    <Container>
      <s-heading fontSize='large'>History</s-heading>
      <Intro>Every change made to this shop through CS Admin, newest first. Expand an entry to see what changed.</Intro>
      {id && <AuditTimeline shopId={id} />}
    </Container>
  );
};

export default ShopHistory;

const Container = styled.div`
  display: grid;
  gap: 12px;
  min-width: 0;
`;

const Intro = styled.p`
  color: #6d7175;
`;
